import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, PackageOpen } from 'lucide-react';
import ProductCard from './ProductCard';
import HScroll from './HScroll';

export default function ProductRow({ title, products, categoryHref = '/catalogo', testid, count, showEmpty = false }) {
  const empty = !products || products.length === 0;
  if (empty && !showEmpty) return null;
  return (
    <section className="max-w-7xl mx-auto px-4 py-6 md:py-8" data-testid={testid}>
      <div className="flex items-end justify-between mb-4">
        <h2 className="text-2xl md:text-3xl font-extrabold text-[#1B2A4A]">{title}{count > 0 && <span className="ml-2 align-middle text-xs font-bold text-slate-400">{count} productos</span>}</h2>
        <Link to={categoryHref} className="text-sm font-semibold text-[#1B2A4A] hover:text-yellow-600 underline underline-offset-4">
          Ver todos
        </Link>
      </div>
      {empty ? (
        <Link to={categoryHref} data-testid={testid ? `${testid}-empty` : undefined}
          className="flex items-center gap-4 rounded-2xl border-2 border-dashed border-slate-200 bg-white px-5 py-6 text-slate-500 hover:border-[#F8D13F] transition-colors">
          <PackageOpen size={28} className="text-slate-300 shrink-0" />
          <span className="flex-1 text-sm">Pronto tendremos nuevos productos en esta categoría.</span>
          <ArrowRight size={18} className="text-[#1B2A4A]" />
        </Link>
      ) : (
      <HScroll testid={testid ? `${testid}-scroll` : undefined}>
        {products.map((p) => (
          <div key={p.id} className="snap-start shrink-0 w-[46%] sm:w-[31%] md:w-[23.5%] lg:w-[18.8%]">
            <ProductCard product={p} />
          </div>
        ))}
        {count > products.length && (
          <Link to={categoryHref} data-testid={testid ? `${testid}-more` : undefined}
            className="snap-start shrink-0 w-[46%] sm:w-[31%] md:w-[23.5%] lg:w-[18.8%] rounded-xl bg-[#1B2A4A] text-white flex flex-col items-center justify-center gap-2 font-bold hover:bg-[#24375f] transition-colors">
            <span className="w-12 h-12 rounded-full bg-[#F8D13F] text-[#1B2A4A] grid place-items-center"><ArrowRight size={22} /></span>
            Ver los {count}
          </Link>
        )}
      </HScroll>
      )}
    </section>
  );
}
